import ExtensibilityContext from 'owa-service/lib/contract/ExtensibilityContext';
import { getExtensibilityContext } from 'owa-addins-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { parseConsentStateInfo } from '../util/InClientStoreHelper';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'GetAllPrivateAddIns',
        (data: any, responseMethod: Function) => {
            const context = getExtensibilityContext() as ExtensibilityContext;
            const extensions = context.Extensions;
            const privateExtensions = [];

            extensions.forEach(ext => {
                if (
                    ext.TypeString === 'Private' ||
                    (isFeatureEnabled('addin-inClientStoreDefaultAddinsEnabled') &&
                        ext.TypeString === 'Default')
                ) {
                    privateExtensions.push([
                        ext.Id,
                        ext.Enabled.toString(),
                        parseConsentStateInfo(ext.ConsentState),
                        ext.TypeString.toString(),
                        ext.LicenseStatus.toString(),
                        ext.TrialExpirationDate,
                        ext.Description,
                        ext.ProviderName,
                        ext.IconUrl,
                        ext.HighResolutionIconUrl,
                        ext.DisplayName,
                        ext.RequestedCapabilities.toString(),
                        ext.Version,
                        ext.OriginString,
                        ext.IsMandatory.toString(),
                    ]);
                }
            });
            responseMethod(privateExtensions, 0);
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}
